/* jshint -W079 */
'use strict';

import 'bootstrap/dist/css/bootstrap.css';
import 'angular-ui-notification/dist/angular-ui-notification.css';
import 'font-awesome/css/font-awesome.css';
import 'angular-bootstrap-datetimepicker/src/css/datetimepicker.css';
import '@cgross/angular-busy/dist/angular-busy.css';
import '../../styles/main.less';
import '../../styles/animations.less';

import '../../images/swisspower-logo.small.png';
import '../../images/gfl-logo.small.png';
import '../../images/banner.png';

import '../../index.html';

import angular from 'angular';
import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
import uiRouter from '@uirouter/angularjs';
import 'angular-ui-bootstrap';
import 'angular-ui-validate';
import 'angular-bootstrap-datetimepicker';
import saveAs from 'angular-file-saver';
import moment from 'moment';
import 'moment/locale/de';
import uiNotification from 'angular-ui-notification';
import angularHttpAuthInterceptor from 'angular-http-auth-interceptor';
import textAngular from 'textangular';
import 'textangular/dist/textAngular-sanitize.min';
import cgBusy from '@cgross/angular-busy';
import 'angular-date-time-input';
import 'angular-animate';

import {config} from './app.config.js';
import CrudService from './services/crudservice';
import User from './services/user';
import AuthService from './services/authservice';
import '../settings/settings.module';
import '../patients/patients.module';
//import '../statistics/statistics.module';

require('bootstrap');

export default angular
  .module('emilApp', [
    'emilSettings', 'emilPatients', 
    //'emilStatistics',
    saveAs,
    uiRouter,
    'ui.bootstrap',
    uiNotification,
    angularHttpAuthInterceptor,
    'ui.bootstrap.datetimepicker',
    textAngular,
    'ui.validate',
    'ui.dateTimeInput',
    'ngAnimate',
    cgBusy
  ])
  .config(['$stateProvider', '$httpProvider', '$urlRouterProvider', '$compileProvider', 'NotificationProvider', '$provide', '$qProvider',
           function ($stateProvider, $httpProvider, $urlRouterProvider, $compileProvider, NotificationProvider, $provide, $qProvider) {

    $stateProvider
      .state('main', {
        abstract: true,
        url: '/',
        template: '<ui-view/>',
        data: {
          proxy: 'main.home'
        }
      })
      .state('main.home', {
        url: '',
        template: require('./views/main.html'),
        data: {
          displayName: 'Start'
        }
      })
      .state('main.contact', {
        url: 'kontakt',
        component: 'contact',
        params: {
          'permission': '11111'
        },
        data: {
          displayName: 'Kontakt'
        }
      })
      .state('main.impressum', {
        url: 'impressum',
        template: '<h2>Impressum</h2><p ng-bind-html="impressum" id="impressum"></p>',
        controller: ['$scope', 'settings', function($scope, settings){
          $scope.impressum = settings.impressum;
        }],
        resolve: {
          settings: ['CRUDService', 'config', function(CRUDService, config) {
            return CRUDService.getAll(config.urls.settings);
          }],
        },
        data: {
          displayName: 'Impressum'
        }
      })
      .state('main.downloads', {
        url: 'downloads',
        template: require('./views/downloads.html'),
        data: {
          displayName: 'Downloads'
        }
      })
      .state('main.messages', {
        url: 'nachrichten',
        template: '<messages></messages>',
        params: {
          permission: '11111'
        },
        data: {
          displayName: 'Nachrichten'
        }
      })
      .state('main.messages.details', {
        url: '/:uuid',
        component: 'messageDetails',
        resolve: {
          'message': ['$stateParams', function ($stateParams) {
            return $stateParams.message;
          }]
        },
        bindings: {
          message: 'message'
        },
        params: {
          permission: '11111',
          message: undefined
        },
        data: {
          displayName: 'Details'
        }
      })
    ;

    $urlRouterProvider.otherwise('/');

    $httpProvider.interceptors.push('defaultInterceptor');

    $httpProvider.defaults.withCredentials = true;

    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|blob):/);

    $qProvider.errorOnUnhandledRejections(false);

    NotificationProvider.setOptions({
      positionX: 'center'
    });

    // configure textangular wysiwyg editor
    $provide.decorator('taOptions', ['$delegate', function(taOptions) { // $delegate is the taOptions we are decorating
      taOptions.toolbar = [
        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
        ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
        ['insertLink']
      ];
      taOptions.forceTextAngularSanitize = false;

      return taOptions;
    }]);
    $provide.decorator('taTranslations', ['$delegate', function($delegate) {
      $delegate.heading.tooltip = 'Überschrift ';
      $delegate.pre.tooltip = 'Vorformatierter Text';
      $delegate.quote.tooltip = 'Zitat';
      $delegate.justifyLeft.tooltip = 'Linksbündig';
      $delegate.justifyCenter.tooltip = 'Zentriert';
      $delegate.justifyRight.tooltip = 'Rechtsbündig';
      $delegate.bold.tooltip = 'Fett';
      $delegate.italic.tooltip = 'Kursiv';
      $delegate.underline.tooltip = 'Unterstrichen';
      $delegate.strikeThrough.tooltip = 'Durchgestrichen';
      $delegate.ul.tooltip = 'Ungeordnete Liste';
      $delegate.ol.tooltip = 'Geordnete Liste';
      $delegate.indent.tooltip = 'Einzug erhöhen';
      $delegate.outdent.tooltip = 'Einzug verringern';
      $delegate.clear.tooltip = 'Formatierung entfernen';
      $delegate.undo.tooltip = 'Rückgängig';
      $delegate.redo.tooltip = 'Wiederholen';
      $delegate.insertLink.tooltip = 'Link einfügen';
      $delegate.insertLink.dialogPrompt = "Geben sie die Link-Adresse an:";
      return $delegate;
    }]);
  }])
  .value('cgBusyDefaults',{
    message: 'Wird geladen.',
    backdrop: true,
    wrapperClass: 'busy-loading'
  })
  .run(['$rootScope', '$location', '$transitions', '$trace', '$state', '$http', 'AuthService', 'Notification', '$templateCache', 'config', 'CRUDService',
    function($rootScope, $location, $transitions, $trace, $state, $http, AuthService, Notification, $templateCache, config, CRUDService){
    // disable ui-router tracing and error logging
    $trace.disable();
    $state.defaultErrorHandler(function() {});

    var reload = true;

    $transitions.onBefore({}, function(trans){
      // restore user object after page refresh
      if (reload){
        return $http.get('/api/users/current', {ignoreAuthModule: true}).then(function (response) {

          $rootScope.user = User.build(response.data);

          CRUDService.getAll(config.urls.messages + '/search/count').then(function(data){
            $rootScope.user.messages = data;
          });

          // check given state permission
          var params = trans.params();
          if (params.hasOwnProperty('permission')) {
            if (!$rootScope.user || !$rootScope.user.hasPermission(params.permission)) {
              Notification.error('Sie sind nicht berechtigt die angeforderte Seite zu öffnen.');
              if ($rootScope.user) {
                return false;
              }
              trans.router.stateService.transitionTo('main.home');
              return true;
            }
          }
        }, function () {
          // session expired or something unexpected happened.. better get out of here
          if ($rootScope.user){
            AuthService.logout();
          } else {
            trans.router.stateService.target('main.home', undefined, { location: true });
          }
        });
      } else {
        // check given state permission
        var params = trans.params();
        if (params.hasOwnProperty('permission')) {
          if (!$rootScope.user || !$rootScope.user.hasPermission(params.permission)) {
            Notification.error('Sie sind nicht berechtigt die angeforderte Seite zu öffnen.');
            if (!$rootScope.user) {
              trans.router.stateService.transitionTo('main.home');
              return true;
            }
            return false;
          }
        }
      }
    });

    $rootScope.$on('event:auth-loginRequired', function(){
      $rootScope.user = false;
      $state.go('main.home');
      Notification.error('Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.');
    });

    // overwrite the default datetimepicker template
    // the template is copied from views/datepicker.html but has to be directly put to the template cache
    $templateCache.put('templates/datetimepicker.html', '<div class="datetimepicker"><table class="table table-condensed {{ data.currentView }}-view"> <thead> <tr> <th class="left" data-ng-click="changeView(data.currentView, data.leftDate, $event)" data-ng-show="data.leftDate.selectable"><i class="glyphicon glyphicon-arrow-left"><span class="sr-only">{{ screenReader.previous }}</span></i> </th> <th class="switch" colspan="5" data-ng-show="data.previousViewDate.selectable" data-ng-click="changeView(data.previousView, data.previousViewDate, $event)">{{ data.previousViewDate.display }}</th> <th class="right" data-ng-click="changeView(data.currentView, data.rightDate, $event)" data-ng-show="data.rightDate.selectable"><i class="glyphicon glyphicon-arrow-right"><span class="sr-only">{{ screenReader.next }}</span></i> </th> </tr> <tr> <th class="dow" data-ng-repeat="day in data.dayNames">{{ day }}</th> </tr> </thead> <tbody> <tr data-ng-if="data.currentView !== \'day\'"> <td colspan="7"> <span class="{{ data.currentView }}" data-ng-repeat="dateObject in data.dates" data-ng-class="{current: dateObject.current, active: dateObject.active, past: dateObject.past, future: dateObject.future, disabled: !dateObject.selectable}" data-ng-click="changeView(data.nextView, dateObject, $event)">{{ dateObject.display }}</span></td> </tr> <tr data-ng-if="data.currentView === \'day\'" data-ng-repeat="week in data.weeks"> <td data-ng-repeat="dateObject in week.dates" data-ng-click="changeView(data.nextView, dateObject, $event)" class="day" data-ng-class="{current: dateObject.current, active: dateObject.active, past: dateObject.past, future: dateObject.future, disabled: !dateObject.selectable}">{{ dateObject.display }}</td> </tr> </tbody> </table></div> ');

    // set moment.js default locale
    moment.locale('de');

    // move static config object to root scope
    $rootScope.config = config;

    var pjson = require('../../../../../package.json');//
    $rootScope.config.version = pjson.version;
  }])
  .filter('orderObjectBy', function() {
    return function(items, field, reverse) {
      var filtered = [];
      angular.forEach(items, function(item) {
        filtered.push(item);
      });
      filtered.sort(function (a, b) {
        return (a[field] > b[field] ? 1 : -1);
      });
      if(reverse) filtered.reverse();
      return filtered;
    };
  })
  .constant('config', config)
  /// Module loading
  .component('emilButtonAdd', require('./components/emil-button-add'))
  .component('emilButtonDelete', require('./components/emil-button-delete'))
  .component('emilButtonEdit', require('./components/emil-button-edit'))
  .component('emilDatepicker', require('./components/emil-datepicker'))
  .component('emilEditor', require('./components/emil-editor'))
  .component('emilHeader', require('./components/header/emil-header.component'))
  .component('emilFooter', require('./components/footer/emil-footer.component'))
  .component('login', require('./components/login/login.component.js'))
  .component('logout', require('./components/logout'))
  .component('contact', require('./components/contact/contact.component'))
  .component('messages', require('./components/messages/messages.component'))
  .component('messageDetails', require('./components/message-details/message-details.component'))
  .component('news', require('./components/news/news.component'))
  .component('sessionTimeout', require('./components/session-timeout.component'))

  .directive('confirm', require('./components/confirm'))
  .directive('editorMaxlength', require('./components/editor-maxlength'))
  .directive('infiniteScroll', require('./components/infinite-scroll'))
  .directive('passwordValidator', require('./components/passwordValidator'))
  .directive('breadcrumbs', require('./components/breadcrumbs/breadcrumbs.directive'))

  .factory('defaultInterceptor', require('./services/defaultinterceptor'))

  .service('User', [User])
  .service('AuthService', AuthService)
  .service('CRUDService', CrudService)
;



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/app.js